import Vue from 'vue';
import queryString from 'query-string';

export default {
    /**
     * Check whether the current instance is an SPA
     *
     * @returns {Boolean}
     */
    isSPA() {
        return Boolean(Object.keys(Vue._installedPlugins).find((key) => Vue._installedPlugins[key].name === 'VueRouter'));
    },

    query() {
        return queryString.parse(window.location.search);
    },
};
